import { Injectable } from '@angular/core';
import { ProductInformation } from '../../../../shared/objects/transport-information/product-information';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class ContainerService {
    public compartments$: BehaviorSubject<ProductInformation[]>;
    public compartmentsDataSource: ProductInformation[];

    constructor() {
        this.compartmentsDataSource = [];
        this.compartments$ = new BehaviorSubject<ProductInformation[]>(this.compartmentsDataSource);
    }

    updateData(compartments: ProductInformation[]): void {
        this.compartmentsDataSource = compartments;
        this.compartments$.next(this.compartmentsDataSource);
    }

    public addCompartment(compartment: ProductInformation) {
        this.compartmentsDataSource.push(compartment);
        this.compartments$.next(this.compartmentsDataSource);
    }

    public updateCompartment(compartment: ProductInformation) {
        const foundIndex = this.findCompartmentIndexBy(compartment.compartmentNumber);
        this.compartmentsDataSource[foundIndex] = { ...compartment };
        this.compartments$.next(this.compartmentsDataSource);
    }

    public deleteCompartment(compartment: ProductInformation) {
        const foundIndex = this.findCompartmentIndexBy(compartment.compartmentNumber);
        this.compartmentsDataSource.splice(foundIndex, 1);
        this.compartments$.next(this.compartmentsDataSource);
    }

    private findCompartmentIndexBy(number: number): number {
        return this.compartmentsDataSource.findIndex(c => c.compartmentNumber === number);
    }
}
